<template>
  <vue-countdown
    :time="
      props.secondsRemaining <= 0 || props.secondsRemaining === null
        ? 0
        : props.secondsRemaining
    "
    v-slot="{ days, hours, minutes, seconds }"
  >
    <div
      class="font-weight-bold mb-2"
      :class="minutes < 5 ? 'text-red' : 'text-wb'"
    >
      Time Remaining
    </div>
    <div class="d-flex align-center justify-center">
      <span :class="minutes < 5 ? 'text-red' : 'text-wb'">
        {{ hours.toString().padStart(2, "0") }}:
      </span>
      <span :class="minutes < 5 ? 'text-red' : 'text-wb'">
        {{ minutes.toString().padStart(2, "0") }}:
      </span>
      <span :class="minutes < 5 ? 'text-red' : 'text-wb'">
        {{ seconds.toString().padStart(2, "0") }}
      </span>
    </div>
  </vue-countdown>
</template>

<script setup>
  const props = defineProps(["secondsRemaining"]);
</script>
